import React, { useState, useEffect } from 'react';
import Styled from 'styled-components'
import {FaSearch} from 'react-icons/fa';
import api from '../services/api';
import {
    ModalHeader,
    ModalBody,
    Table
  } from 'reactstrap'

const BackgroundModal = Styled.div`
    position: fixed;
    z-index: 90;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0,0,0,0.5);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`;

const ModalView = Styled.div`
    margin: 0 10px;
    display: flex;
    margin-top: -40%;
    background-color: #fff;
    border-radius: 3px;
    width: 90%;
    min-height: 10%;
    flex-direction: column;
`;

const ModalListLeads = (props) => {
    let id_company = localStorage.getItem('followize_id_company');
    let id_contact = localStorage.getItem('followize_id_contact');
    let id_user = localStorage.getItem('followize_id_user');

    const getLead = async()=>{
        const response = await api.get(`lead/list?id_company=${id_company}&id_contact=${id_contact}&id_user=${id_user}`);
        setLead(response.data)
    }

    const [leads, setLead] = useState([])

    useEffect(() => {
        getLead()
    }, [])

    const closeModal = () => {
        props.modalVisible(false);
    }

    return (
        <>
            {props.visible === true &&
                <BackgroundModal>
                    <ModalView>
                        <ModalHeader>
                            <h3 style={{textAlign:'center'}}>Lista de Leads</h3>
                        </ModalHeader>
                        <ModalBody>
                        <Table>
                            <thead>
                                <tr>
                                    <th>Nome do Lead</th>
                                    <th>&nbsp;</th>
                                </tr>
                            </thead>

                            <tbody>
                                {leads.length > 0 && leads.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.lead_name}</td>
                                        <td>
                                            <button
                                                style={{border: 'none', width: '80%', height: 'auto', backgroundColor: '#52648d', color: '#fff', borderRadius: '10%', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '15%'}}
                                                color='info'
                                                onClick={() => window.open("https://app.followize.com.br/leads/" + item.lead_id)}
                                            >
                                                <FaSearch />
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                                {!leads.length && (
                                    <tr>
                                        <td colSpan={2}>Nenhum lead cadastrado</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                            <button className="button" onClick={closeModal} style={{height:'45px'}}>Sair</button>
                        </ModalBody>
                    </ModalView>
                </BackgroundModal>
            }
        </>
    )
}

export default ModalListLeads;